module.exports = __webpack_public_path__ + "img/icon-a-1.4f032117.svg";